import { Link, LinkProps } from '@chakra-ui/react';
import { MouseEvent, RefObject, TouchEvent } from 'react';

import { NavigationLink } from '../../ShareNavBar.model';

type OnClickTouchEvent =
  | MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
  | TouchEvent<HTMLAnchorElement>;

interface Props extends LinkProps {
  navigationLinks: NavigationLink[];
  activeIndex: number;
  sectionsRefs?: RefObject<HTMLElement>[];
  onClick?: (event: OnClickTouchEvent) => void;
}

export const NavLinks: React.FC<Props> = ({
  navigationLinks,
  activeIndex,
  onClick,
  sectionsRefs,
  ...props
}) => {
  const handleClick = (event: OnClickTouchEvent, href: string) => {
    event.preventDefault();

    // To redirect to the section title and due to the sticky menu we have in the media packs,
    // we have to calculate the offset, because
    // the native browser redirection would leave the menu overlapped.
    const element = sectionsRefs?.find((ref) => href === `#${ref?.current?.id}`)
      ?.current;
    if (element) {
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    if (onClick) {
      onClick(event);
    }
  };
  return (
    <>
      {navigationLinks.map(({ href, label }, index) => (
        <Link
          fontSize="md"
          fontWeight={activeIndex === index ? 'medium' : 'regular'}
          color={activeIndex === index ? 'white' : 'primary.100'}
          key={href}
          onTouchStart={(event) => handleClick(event, href)}
          onClick={(event) => handleClick(event, href)}
          _hover={{
            textDecoration: 'none',
          }}
          role="button"
          {...props}
        >
          {label}
        </Link>
      ))}
    </>
  );
};
